{
    "comment_slider.its_complicated": "Neutraal",
    "comment_slider.no_with_reservations": "Oneens",
    "comment_slider.strongly_no": "Helemaal oneens",
    "comment_slider.strongly_yes": "Helemaal eens",
    "comment_slider.yes_with_reservations": "Eens"
}
